import { AppRoute } from '@shared/config'

export interface CustomerTab {
  path: AppRoute
  label: string
}

/** The customer's tab bar in the legacy order. The breadcrumbs name the open tab with the same label. */
export const CUSTOMER_TABS: CustomerTab[] = [
  { path: AppRoute.CustomersShow, label: 'General info' },
  { path: AppRoute.CustomersSubscriptions, label: 'Subscriptions' },
  { path: AppRoute.CustomersOrders, label: 'Orders' },
  { path: AppRoute.CustomersCredits, label: 'Credits' },
  { path: AppRoute.CustomersChangelog, label: 'Changelog' },
  { path: AppRoute.CustomersDetails, label: 'Details' },
  { path: AppRoute.CustomersStatusesAndSources, label: 'Statuses & sources' },
  { path: AppRoute.CustomersComments, label: 'All comments' },
  { path: AppRoute.CustomersTaskComments, label: 'Task comments' },
]
